<!-- src/app/app.component.html -->


  <!-- Navbar (مخفي على الهوم بيس فقط) -->
  <app-navbar
    *ngIf="isPortal"
    class="navbar-fixed">
  </app-navbar>

   <!-- <app-navbar

    class="navbar-fixed">
  </app-navbar> -->

  <!-- المحتوى الرئيسي -->
  <main class="main-content" [class.portal-padding]="isPortal">
    <app-spinner></app-spinner>
    <router-outlet></router-outlet>
  </main>

  <!-- Footer دايماً موجود -->
  <app-footer class="app-footer"></app-footer>
